<template>
    <v-container fluid class="b-container">
        <v-sheet class="pa-3">
            <v-tabs v-model="tab" color="black">
                <v-tab
                    v-for="tab in tabs"
                    :key="tab.name"
                    v-text="tab.name"
                    :to="tab.to"
                    class="text-capitalize"
                ></v-tab>
            </v-tabs>

            <v-tabs-items v-model="tab">
                <router-view></router-view>
            </v-tabs-items>
        </v-sheet>
    </v-container>
</template>

<script>
import translations from "@/utils/translations/supplierPanel/sendReports";
export default {
    name: "SendReports",

    mixins: [translations],

    data() {
        return {
            tab: this.$route.path
        };
    },

    computed: {
        lang() {
            return this.$route.params.lang;
        },

        tabs() {
            return [
                {
                    to: `/${this.lang}/supplierPanel/send-reports/pending`,
                    name: this.translations.pending[this.lang]
                },
                {
                    to: `/${this.lang}/supplierPanel/send-reports/paid`,
                    name: this.translations.sent[this.lang]
                }
            ];
        }
    },

    watch: {
        $route: {
            immediate: true,
            handler(val) {
                if (val.path === `/${this.lang}/supplierPanel/send-report`) {
                    this.$router.push(
                        `/${this.lang}/supplierPanel/send-report/pending?page=1`
                    );
                }
            }
        }
    }
};
</script>
